import { render, staticRenderFns } from "./ncrBreakdownWidget.vue?vue&type=template&id=0bc87b33&"
import script from "./ncrBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./ncrBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports